import React from "react";
import PropTypes from "prop-types";
import FormEditor from "components/editor";
import withStyles from "components/with-styles";
import styles from "./styles/form.css.js";

const EditRoomTemplateFileForm = ({ classes, handleChange, values}) => (
  <div className={classes.fileEditor}>
    <FormEditor name="file" value={values.file} onChange={handleChange} />
  </div>
);

EditRoomTemplateFileForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default withStyles(styles)(EditRoomTemplateFileForm);
